var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"drag-resize",class:{
        'drag-resize--disabled': _vm.disabled,
        'drag-resize--bottom': _vm.triangle,
    }})
}
var staticRenderFns = []

export { render, staticRenderFns }